import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { AvatarInput } from '../AvatarInput';

import { FIELD_AVATAR } from '@widgets/signUp/signUpVolunteer/signUpVolunteerPrivatePerson/constants';
import config from '@config';

export const AvatarFormInput = () => {
  const { control } = useFormContext();

  if (!config.features.userAvatar) {
    return null;
  }

  return (
    <Controller
      name={FIELD_AVATAR}
      control={control}
      render={({ field: { value, onChange } }) => {
        return <AvatarInput value={typeof value === 'string' ? value : null} onChange={onChange} />;
      }}
    />
  );
};
